import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Brand, PrimaryButton } from "../components/UI";
import { loginUser } from "../services/auth";
import { useApp } from "../store";

import "../css/Login.css";
export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useApp();
  const redirectTo =
    new URLSearchParams(location.search).get("redirect") || "/home";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(event) {
    event.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await loginUser({ email, password });
      setUser(user);
      navigate(redirectTo, { replace: true });
    } catch (err) {
      setError(err?.message || "Unable to login. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-page-simple">
      <div className="auth-card-simple">
        <Brand />
        <span className="eyebrow">Fresh delivery, Pune</span>
        <h1>Welcome back</h1>
        <p>Login to continue.</p>

        <form onSubmit={submit} className="form-card">
          <label className="form-label">Email</label>
          <input
            className="form-control form-control-lg mb-3"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
          />

          <label className="form-label">Password</label>
          <input
            className="form-control form-control-lg mb-3"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />

          {error && <div className="alert alert-danger">{error}</div>}
          <PrimaryButton
            type="submit"
            className="w-100 btn-lg"
            disabled={loading}
          >
            {loading ? "Please wait…" : "Login"}
          </PrimaryButton>
        </form>

        <p className="text-center mt-3 mb-0">
          Don't have an account?{" "}
          <Link to={`/register?redirect=${encodeURIComponent(redirectTo)}`}>
            Register
          </Link>
        </p>
      </div>
    </div>
  );
}
